<template>
  <div class="px-[24px] h-screen flex flex-col justify-center">
    <div class="">
      <img
        v-if="isKids"
        src="/images/findee-logo.png"
        class="mx-auto"
        alt="logo"
      />
      <FindeePetsLogo
        v-else-if="isPets"
        class="mx-auto"
      />
      <GuardianLogo v-else />

      <StrongTitle
        :class="{
          'mt-8': isKids || isPets,
          'mt-4': isGuardian
        }"
      >
        {{ $t('forgot_password_title') }}
      </StrongTitle>

      <div
        class="text-grey-1 text-center mt-8"
        v-html="$t('forgot_password_text')"
      ></div>

      <EmailInput
        v-model="state.email"
        v-model:valid="state.valid"
        class="mt-5"
      />

      <ErrorWidget v-if="hasError">
        {{ $t('email_not_exist') }}
      </ErrorWidget>

      <SocialAuthUsed
        v-if="useProvider"
        :provider="useProvider"
        class="mt-4"
      />

      <BaseButton
        class="mt-8"
        :disabled="!state.valid"
        @click="getResetLinkOnEmail"
      >
        {{ $t('continue') }}
      </BaseButton>

      <BaseButton
        :outline="true"
        class="mt-2"
        @click="router.push({ name: ROUTE_NAMES.LOGIN })"
      >
        {{ $t('back_to_login') }}
      </BaseButton>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import BaseButton from '@/components/buttons/BaseButton.vue'
import StrongTitle from '@/components/ui/StrongTitle.vue'
import EmailInput from '@/components/inputs/EmailInput.vue'
import { useRouter } from 'vue-router'
import { ROUTE_NAMES } from '@/router'
import { getPasswordResetLink } from '@/services/api/Auth'
import ErrorWidget from '@/components/ui/ErrorWidget.vue'
import SocialAuthUsed from '@/components/ui/SocialAuthUsed.vue'
import GuardianLogo from '@/assets/images/guardian/logo/LogoHorizontal.vue'
import FindeePetsLogo from '@/assets/images/pets/LogoHorizontal.vue'
import { isKids, isGuardian, isPets } from '@/comp/AppType'

const router = useRouter()

const state = reactive({
  email: '',
  valid: false
})

const loading = ref(true)
const hasError = ref(false)
const useProvider = ref(false)

const getResetLinkOnEmail = async () => {
  loading.value = true
  const { statusCode, response } = await getPasswordResetLink(state.email)
  loading.value = false
  if (statusCode.value === 422) {
    try {
      const responseBody = response.value ? await response.value.json() : null
      if (!responseBody?.userIdentityProviderTypes?.includes('Google')) useProvider.value = 'Apple'
      else useProvider.value = 'Google'
      return
    } catch (e) {
      console.log('e', e)
    }
    hasError.value = true
    return
  }
  if (statusCode.value !== 200) {
    hasError.value = true
    return
  }
  await router.push({ name: ROUTE_NAMES.PASSWORD_RESET_EMAIL_SEND, query: { email: state.email } })
}
</script>
